import {
  Box,
  Flex,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import ProspectModal from "./ProspectModal";
import { crm, Pill } from "../../../theme";

const ProspectItem = ({
  p,
  get,
}: {
  p: any;
  get: () => Promise<any>;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Flex
        cursor="pointer"
        onClick={onOpen}
        alignItems="center"
        gap="8px"
        p="12px 16px"
        borderRadius={crm.radius}
        border={`1px solid ${crm.border}`}
        boxShadow={crm.shadowSm}
        bg={crm.surface}
        transition="all 0.15s ease"
        _hover={{
          boxShadow: crm.shadowMd,
          transform: "translateY(-1px)",
          borderColor: crm.brand,
        }}
      >
        <Text color={crm.text} fontWeight="500" textAlign="center">{p.company.name}</Text>
        <Box textAlign="center">
          <Pill
            bg={p.company.status === "Ativo" ? "#dcfce7" : "#fef9c3"}
            color={p.company.status === "Ativo" ? crm.success : "#92400e"}
          >
            {p.company.status}
          </Pill>
        </Box>
      </Flex>
      <ProspectModal {...{ get, isOpen, onClose, p }} />
    </>
  );
};

export default ProspectItem;
